export default __webpack_public_path__ + "static/media/quiz-reg.081d1d43.jpg";